import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {HomeRoutingModule} from './home-routing.module';
import {MatTabsModule} from '@angular/material/tabs';
import {HomeComponent} from './components/home/home.component';
import {HmCoverageComponent} from './components/hm-coverage/hm-coverage.component';
import {HmHiringComponent} from './components/hm-hiring/hm-hiring.component';
import {HmRatesComponent} from './components/hm-rates/hm-rates.component';
import {HmHeaderModule} from './components/hm-header/hm-header.module';
import { HmPromoComponent } from './components/hm-promo/hm-promo.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import { MatMenuModule } from '@angular/material/menu';
import { HmSupportComponent } from './components/hm-support/hm-support.component';
import { HmGpvComponent } from './components/hm-gpv/hm-gpv.component';
import { HmCoberturaComponent } from './components/hm-cobertura/hm-cobertura.component';
import { HmManualsComponent } from './components/hm-manuals/hm-manuals.component';
import { HmModalSimyoContratosComponent } from './components/hm-modal-simyo-contratos/hm-modal-simyo-contratos.component';
import { HmSalesComponent } from './components/hm-sales/hm-sales.component';
import { HmOperationsComponent } from './components/hm-operations/hm-operations.component';
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HmCommissionsComponent } from './components/hm-commissions/hm-commissions.component';
import { HmModalMrComponent } from './components/hm-modal-mr/hm-modal-mr.component';
import { SharedModule } from '../shared/shared.module';
import { HmModalJazztelContratosComponent } from './components/hm-modal-jazztel-contratos/hm-modal-jazztel-contratos.component';
import { HmOperationsPosventaComponent } from './components/hm-operations-posventa/hm-operations-posventa.component';
import { HmModalSimyoImageComponent } from './components/hm-modal-simyo-image/hm-modal-simyo-image.component';
import { MovementsComponent } from './components/hm-points/movements/movements.component';
import { HomePointsComponent } from './components/hm-points/home-points/home-points.component';
import { AcceptedPointsProgramComponent } from './components/hm-points/modals/accepted-points-program/accepted-points-program.component';
import { OrdersComponent } from './components/hm-points/orders/orders.component';
import { PointOrderComponent } from './components/hm-points/order/order.component';
import { BannerComponent } from './components/hm-points/modals/banner/banner.component';
import { TestComponentComponent } from './test-component/test-component.component';
import { HmBrandComponent } from './components/hm-hiring/components/hm-brand/hm-brand.component';
import { HmModalCommissionsComponent } from './components/hm-modal-commissions/hm-modal-commissions.component';
import { HmModalContractConditionsComponent } from './components/hm-modal-contract-conditions/hm-modal-contract-conditions.component';
import { HmInfoModalComponent } from './components/hm-info-modal/hm-info-modal.component';

@NgModule({
    declarations: [
        HomeComponent,
        HmCoverageComponent,
        HmHiringComponent,
        HmRatesComponent,
        HmPromoComponent,
        HmSupportComponent,
        HmGpvComponent,
        HmCoberturaComponent,
        HmManualsComponent,
        HmModalSimyoContratosComponent,
        HmSalesComponent,
        HmOperationsComponent,
        HmCommissionsComponent,
        HmModalMrComponent,
        HmModalJazztelContratosComponent,
        HmOperationsPosventaComponent,
        HmModalSimyoImageComponent,
        HomePointsComponent,
        MovementsComponent,
        AcceptedPointsProgramComponent,
        OrdersComponent,
        PointOrderComponent,
        BannerComponent,
        TestComponentComponent,
        HmBrandComponent,
        HmModalCommissionsComponent,
        HmModalContractConditionsComponent,
        HmInfoModalComponent
    ],
    exports: [
        HmHeaderModule
    ],
    imports: [
        CommonModule,
        HomeRoutingModule,
        MatTabsModule,
        MatDialogModule,
        MatButtonModule,
        MatTableModule,
        MatSlideToggleModule,
        SharedModule,
        MatMenuModule,
        HmHeaderModule
    ]
})

export class HomeModule {
}
